import { ButtonHTMLAttributes, ReactNode, forwardRef } from 'react';
import { ButtonStyle, ShowloaderWrap } from './styles';
import { Interpolation } from 'styled-components';
import CustomTooltip from '../Tooltip';
import { PlacesType } from 'react-tooltip';

export interface CustomButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	showLoader?: boolean,
	styles?: Interpolation<React.CSSProperties>;
	children?: ReactNode;
	tooltipContent?: string;
	tooltipPlace?: PlacesType;
}

const Button = forwardRef<HTMLButtonElement, CustomButtonProps>((props, ref ) => {
	const { showLoader, children, className, id, tooltipContent, tooltipPlace, ...rest } = props;
	const buttonClassName = `${className || ''} ${showLoader ? 'show Loader' : ''}`;
	return (
		<>
			<ButtonStyle
				id={id}
				className={buttonClassName}
				ref={ref}
				{...rest}
			>
				{children}
				{showLoader && 
				<ShowloaderWrap className='showLoader-wrap'><span className='showLoader'></span></ShowloaderWrap>
				} 

			</ButtonStyle>

			<CustomTooltip elementID={id!} content={tooltipContent} place={tooltipPlace} />
		</>
	);
});

Button.displayName = 'CustomButton';
export default Button;
